import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { company } from '~/company/Company';
import { useHttpStatus } from '~/utils/ssrResponseStatus';

import MobileHeaderLayout from '../Main/MobileHeader/MobileHeaderLayout';
import MobileLogo from '../Main/MobileHeader/MobileLogo';

import styles from './NotFound.module.scss';

const NotFound = ({ embedded }: { embedded?: boolean }) => {
  const { t } = useTranslation();
  useHttpStatus(404);

  const getPageHeader = () => {
    if (embedded) {
      return null;
    } else {
      return (
        <>
          <MobileLogo />
          <MobileHeaderLayout showSearch />
        </>
      );
    }
  };

  return (
    <div className={styles.container} data-company={company.name}>
      <Helmet>
        <meta
          data-react-helmet="true"
          name="robots"
          content="noindex, nofollow"
        />
      </Helmet>
      {getPageHeader()}
      <div className={styles.fullWidthContainer} data-company={company.name}>
        <div
          className={classes([
            'content-layout',
            'not-found-content-layout',
            styles.root,
          ])}
          data-company={company.name}
        >
          <p className={styles.disclaimer}>{t('phrases:404WereHoping')}</p>
          <img
            src={company.images[404].notFound}
            className={styles.image}
            alt=""
          />
          <p className={styles.mainContent}>
            <Trans
              i18nKey="phrases:404ThisPage"
              components={{ a: <Link to="/" className={styles.inlineLink} /> }}
            />
          </p>
          <Link
            to="/"
            className={classes(['button _primary _big', styles.button])}
          >
            {t('goToHomepage')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default observer(NotFound);
